import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { SiteQuery } from '../model/query/site-query';
import { SiteDetailQuery } from '../model/query/site-detail-query';
import { ScaffoldInspectionQuery } from '../model/query/scaffold-inspection-query';
import { SiteScaffoldQuery } from '../model/query/site-scaffold-query';
import { SiteStatisticsQuery } from '../model/query/site-statistics-query';
import { SiteContractInspectionStatusQuery } from '../model/query/site-contract-inspection-status-query';
import { SiteScaffoldDiaryQuery } from '../model/query/site-scaffold-diary-query';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the Site API endpoint.
@Injectable()
export class SiteEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  SiteQuery(queryData: SiteQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  SiteDetailQuery(queryData: SiteDetailQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteDetailQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  ScaffoldInspectionQuery(queryData: ScaffoldInspectionQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.ScaffoldInspectionQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  SiteScaffoldQuery(queryData: SiteScaffoldQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteScaffoldQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  SiteStatisticsQuery(queryData: SiteStatisticsQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteStatisticsQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  SiteContractInspectionStatusQuery(queryData: SiteContractInspectionStatusQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteContractInspectionStatusQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  SiteScaffoldDiaryQuery(queryData: SiteScaffoldDiaryQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.SiteScaffoldDiaryQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  Sync(ifModifiedSince: string, isInitialLoad: boolean): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Site?ifModifiedSince=' + ifModifiedSince + '&isInitialLoad=' + isInitialLoad,
      options);
  }

  GetSingle(siteId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Site/' + siteId,
      options);
  }
}
